<template>
    <div class="relative">
        <!-- Limited by stock qty message  -->
        <jet-tooltip v-show="showStockWarning">
            Only {{ product.available * 1}} Available
        </jet-tooltip>

        <div v-if="isFetching" class="max-w-full border border-gray bg-gray-light rounded-md" style="height: 34px;">
            ...
        </div>
        <div v-else-if="product.available > 0" class="button-group justify-center max-w-full">
            <button type="button" @click="decrement()">
                <img src="/images/icons/minus.svg" alt="Decrement Quantity" width="18" height="18" />
            </button>
            <input-quantity
                v-model.number="quantityInCart"
                class="text-center w-full quantity rounded-none"
                :step="product.allow_partial_quantity ? 0.5 : 1"
                :max="product.available"
                @stockWarning="stockWarning"
            />
            <button type="button" @click="increment()">
                <img src="/images/icons/plus.svg" alt="Increment Quantity" width="18" height="18" />
            </button>
        </div>
        <div class="sold-out" v-else>Sold out, coming soon!</div>
    </div>
</template>

<script>
import { computed } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3'
import UseCart from '@/Composables/UseCart';
import InputQuantity from '@/Jetstream/InputQuantity';
import JetTooltip from '@/Jetstream/Tooltip';

export default {
    props: ['product'],

    setup (props) {
        const { isFetching, cart, updateCart } = 
            UseCart(
                usePage().props.value.user,
                usePage().props.value.activeCustomer ? usePage().props.value.activeCustomer.tax_exempt : 0
            );

        const quantityInCart = computed({
            get () {
                const cartItem = cart.value.find(item => item.product.id === props.product.id);

                return cartItem ? cartItem.quantity : 0;
            },
            set (newValue) {
                updateCart(props.product, newValue);
            }
        });

        const cartHas2SpecialOrderItems = computed({
            get () {
                return cart.value.filter(item => item.product.special_order == 1).length >= 2;
            },
        });

        return {
            isFetching,
            quantityInCart,
            cartHas2SpecialOrderItems,
        }
    },

    components: {
        InputQuantity,
        JetTooltip,
    },

    data () {
        return {
            loading: true,
            showStockWarning: false,
            stockWarningTimeout: null,
        }
    },

    methods: {
        decrement () {
            this.quantityInCart --;
        },

        increment () {
            this.quantityInCart ++;
        },

        stockWarning () {
            if (this.stockWarningTimeout) clearTimeout(this.stockWarningTimeout);

            this.showStockWarning = true;

            this.stockWarningTimeout = setTimeout(() => {
                this.showStockWarning = false;
                clearTimeout(this.stockWarningTimeout);
            }, 2 * 1000);
        }
    },

    watch: {
        // Determine if the cart has been fetched for us
        isFetching() {
            if (!this.isFetching) {
                this.$nextTick(() => {
                    this.loading = false;
                });
            }
            else {
                this.loading = true;
            }
        },

        quantityInCart (newValue, oldValue) {
            if (this.product.available < this.quantityInCart) {
                this.quantityInCart = this.product.available;
                this.stockWarning();
            }

            // Open special order item modal if it's the first special order item in the cart
            if (!this.loading && newValue > 0 && oldValue == 0 && this.product.special_order && !this.cartHas2SpecialOrderItems) {
                this.$emit('openSpecialOrderItemModal');
            }
        }
    }
}
</script>

<style scoped>
    .available-qty {
        position: absolute;
        bottom: 60px;
        left: calc(50% - 58px);
        background: rgba(0, 0, 0, 0.85);
        border-radius: 8px;
        color: #fff;
        padding: 3px 6px;
        font-size: 14px;
        z-index: 99;
        text-align: center;
    }

    .sold-out {
        font-weight: bold;
        font-size: 14px;
    }
</style>